var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.00268e-07C15.5046 -0.000159579 15.9906 0.190406 16.3605 0.533497C16.7305 0.876588 16.9572 1.34684 16.995 1.85L17 2V4H18C18.5046 3.99984 18.9906 4.19041 19.3605 4.5335C19.7305 4.87659 19.9572 5.34685 19.995 5.85L20 6V15C20.0002 15.5046 19.8096 15.9906 19.4665 16.3605C19.1234 16.7305 18.6532 16.9572 18.15 16.995L18 17H14C13.6758 17.0001 13.3565 16.9213 13.0695 16.7704C12.7826 16.6196 12.5367 16.4011 12.353 16.134L12.268 16H2C1.49542 16.0002 1.00943 15.8096 0.639452 15.4665C0.269471 15.1234 0.0428434 14.6532 0.00500021 14.15L1.00268e-07 14V2C-0.000159579 1.49542 0.190406 1.00943 0.533497 0.639452C0.876588 0.269471 1.34684 0.0428434 1.85 0.00500021L2 1.00268e-07H15ZM18 6H14V15H18V6ZM15 2H2V14H12V6C12 5.46957 12.2107 4.96086 12.5858 4.58579C12.9609 4.21071 13.4696 4 14 4H15V2Z",
    fill: "#F1583C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.fd226003b1858c0098ffef81dddce8ac.svg";
export { ForwardRef as ReactComponent };